<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  modelValue?: string;
  color?: string;
  fontSize?: string;
  fontWeight: number;
  decoration: string;
  margin: string;
  format?: string;
  ellipsis: boolean;
  whiteSpace?: string;
  extStyle?: Record<string, any>;
  emptyPadChar?: string;
}>();

const emit = defineEmits(["click"]);

const style = computed(() => {
  let ret: Record<string, any> = {
    fontSize: props.fontSize,
    fontWeight: props.fontWeight,
    textDecoration: props.decoration,
    margin: props.margin,
  };

  if (props.color) {
    ret.color = props.color;
  }

  if (props.whiteSpace) {
    ret.whiteSpace = props.whiteSpace;
  }

  return ret;
});

const innerStyle = computed(() =>
  props.extStyle ? { ...style.value, ...props.extStyle } : style.value
);

const text = computed(() => {
  if (!props.modelValue) return props.emptyPadChar || "";
  return props.format
    ? props.format.replace(/@value@/g, props.modelValue)
    : props.modelValue;
});
</script>
<template>
  <span
    class="mp-text"
    :class="{ ellipsis }"
    :style="innerStyle"
    @click="emit('click', $event)"
  >
    {{ text }}
  </span>
</template>
<style lang="scss">
.mp-text.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
